import React from 'react';

import { PromoIcon } from 'components/no-auth/common/PromoIcon/PromoIcon';

import { AmountCurrencyFlag, AmountCurrencyLabel, AmountCurrencyText } from './styles';
import { LightFlagIcon } from '../../no-auth/common/fromAuth/LightFlagIcon/LightFlagIcon';
import { PromoText } from '../../no-auth/common/PromoText/PromoText';

const AmountCurrency = (props) => {
    const getDataTestAttr = (isLanding, isFrom) => {
        if (isLanding && isFrom) {
            return '-from';
        }
        if (isLanding && !isFrom) {
            return '-to';
        }
        return '';
    };

    return (
        <AmountCurrencyLabel
            data-testid={`amount-label${getDataTestAttr(props.isLanding, props.isFrom)}`}
            cursorPointer={props.isShowList}
            onClick={props.handlerToggleMenu}
            onKeyPress={props.handlerToggleMenu}
            tabIndex={'0'}
        >
            <AmountCurrencyFlag>
                <LightFlagIcon name={props.countryBean.code} size="x-small" />
            </AmountCurrencyFlag>
            <AmountCurrencyText>
                <PromoText variant="subheader">{props.amountFieldBean.currency}</PromoText>
            </AmountCurrencyText>
            {props.isShowList && <PromoIcon name="chevron-down" color="baseColor" size="24px" />}
        </AmountCurrencyLabel>
    );
};

export default AmountCurrency;
